import { themeVars } from '@tundr/theme';
import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const sectionHeaderClass = style({
  marginBottom: spacingVars['3xl'],
  width: '100%',
});

export const headerContainerClass = style({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: themeVars.space.x14,
});

export const headerLeftSectionClass = style({
  display: 'flex',
  flexDirection: 'column',
});

export const actionsWrapperClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: themeVars.space.x4,
});

export const subtitleWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x2,
  fontSize: themeVars.font.size.h3,
});

export const stepIndicatorClass = style({
  fontSize: themeVars.font.size.textSm,
});
